export default __webpack_public_path__ + "static/media/köide-23-24.58a7a08e.png";